export default "__VITE_ASSET__BkckZucR__"